/**
 * Created by Holger Szuesz <development@szuesz.de> on 30.05.2019 15:48
 *
 */

import * as React from 'react';

import '../styles/Home.css';

class Home extends React.Component<any> {
    public render() {
        return (
            <p className="App-intro">
                To get started, edit <code>src/App.tsx</code> and save to reload.<br />
                this is awesome
            </p>
        );
    }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home.tsx